// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgePayorApi = class EdgePayorApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param payorCoverageMedicalCoverageMedicalCoverageRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async coverageMedicalCoverage(payorCoverageMedicalCoverageMedicalCoverageRequest, xProgramId) {
        const _url_ = '/edge/payor/Coverage/MedicalCoverage';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'payorCoverageMedicalCoverageMedicalCoverageRequest' is not null or undefined
        if (payorCoverageMedicalCoverageMedicalCoverageRequest === null || payorCoverageMedicalCoverageMedicalCoverageRequest === undefined) {
            throw new Error('Required parameter payorCoverageMedicalCoverageMedicalCoverageRequest was null or undefined when calling coverageMedicalCoverage.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(payorCoverageMedicalCoverageMedicalCoverageRequest, "PayorCoverageMedicalCoverageMedicalCoverageRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorCoverageMedicalCoverageMedicalCoverageResponse");
        }
        return response;
    }
    /**
     *
     * @param payorCoveragePharmacyCoveragePharmacyCoverageRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async coveragePharmacyCoverage(payorCoveragePharmacyCoveragePharmacyCoverageRequest, xProgramId) {
        const _url_ = '/edge/payor/Coverage/PharmacyCoverage';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'payorCoveragePharmacyCoveragePharmacyCoverageRequest' is not null or undefined
        if (payorCoveragePharmacyCoveragePharmacyCoverageRequest === null || payorCoveragePharmacyCoveragePharmacyCoverageRequest === undefined) {
            throw new Error('Required parameter payorCoveragePharmacyCoveragePharmacyCoverageRequest was null or undefined when calling coveragePharmacyCoverage.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(payorCoveragePharmacyCoveragePharmacyCoverageRequest, "PayorCoveragePharmacyCoveragePharmacyCoverageRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorCoveragePharmacyCoveragePharmacyCoverageResponse");
        }
        return response;
    }
};
EdgePayorApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgePayorApi);
export { EdgePayorApi };
//# sourceMappingURL=edgePayorApi.js.map